import HeaderSubSection from "../../components/HeaderSubSection/index.vue";

export default {
  name: "confidentialitePage",
  components: {
    HeaderSubSection,
  },
};
